import React from "react";

const tones = {
  Low: "bg-emerald-500/15 text-emerald-300 border-emerald-500/40",
  Moderate: "bg-amber-500/15 text-amber-300 border-amber-500/40",
  High: "bg-rose-500/15 text-rose-300 border-rose-500/40",
  Pursue: "bg-emerald-500/15 text-emerald-300 border-emerald-500/40",
  "Pursue with Caution": "bg-amber-500/15 text-amber-300 border-amber-500/40",
  "Do Not Pursue": "bg-rose-500/15 text-rose-300 border-rose-500/40",
  "Strong Bid": "bg-emerald-500/15 text-emerald-300 border-emerald-500/40",
  "Bid with Caution": "bg-amber-500/15 text-amber-300 border-amber-500/40",
  "No Bid": "bg-rose-500/15 text-rose-300 border-rose-500/40",
  default: "bg-slate-700/30 text-slate-300 border-slate-600",
};

export function RiskBadge({ value, testId }) {
  if (!value) return null;
  const cls = tones[value] || tones.default;
  return (
    <span
      data-testid={testId}
      className={`inline-block font-mono text-[10px] tracking-[0.18em] uppercase px-2.5 py-1 border ${cls}`}
    >
      {value}
    </span>
  );
}

export function KV({ label, value, mono = false }) {
  if (value === undefined || value === null || value === "") return null;
  return (
    <div className="py-2 grid grid-cols-12 gap-3 border-b border-[var(--border-soft)] last:border-0">
      <div className="col-span-4 tick-label pt-0.5">{label}</div>
      <div className={`col-span-8 text-sm text-slate-200 ${mono ? "font-mono" : ""}`}>
        {String(value)}
      </div>
    </div>
  );
}

export function Bullets({ items }) {
  if (!items || items.length === 0) return <div className="text-slate-500 text-sm italic">Not provided.</div>;
  return (
    <ul className="space-y-1.5">
      {items.map((it, i) => (
        <li key={i} className="text-sm text-slate-300 flex gap-3">
          <span className="text-sky-500 font-mono text-xs flex-shrink-0 mt-0.5">▸</span>
          <span>{typeof it === "string" ? it : JSON.stringify(it)}</span>
        </li>
      ))}
    </ul>
  );
}

export function Section({ id, n, title, children }) {
  return (
    <section id={id} data-testid={`report-section-${id}`} className="scroll-mt-24 mb-12">
      <header className="flex items-baseline justify-between border-b border-[var(--border-soft)] pb-3 mb-5">
        <div className="flex items-baseline gap-4">
          <span className="font-mono text-xs text-slate-600">{String(n).padStart(2, "0")}</span>
          <h2 className="font-display font-black text-lg sm:text-xl text-slate-100">{title}</h2>
        </div>
      </header>
      <div>{children}</div>
    </section>
  );
}
